// deep clone columns while preserving functions as-is by copying references for functions
export function cloneColumnsDeep(columns) {
    if (!columns) return [];


    return columns.map((col) => deepCloneCol(col));
}

/**
 * Deep clone a single column object, preserving functions as references 
 * @param {*} col 
 * @returns 
 */
function deepCloneCol(col) {
    const cloned = {};
    for (const key in col) {
        const val = col[key];
        if (Array.isArray(val)) cloned[key] = val.map((v) => (typeof v === 'object' && v !== null ? deepCloneCol(v) : v));
        else if (val && typeof val === 'object') {
            // avoid cloning functions and DOM/templates — keep references
            cloned[key] = {};
            for (const k in val) {
                cloned[key][k] = typeof val[k] === 'object' && val[k] !== null ? JSON.parse(JSON.stringify(val[k])) : val[k];
            }
        } else {
            cloned[key] = val;
        }
    }
    return cloned;
}